import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import axios from "../assets/Icons/axios_logo_icon_168545.png";
import bootstap from "../assets/Icons/icons8-bootstrap-48.png";
import css from "../assets/Icons/icons8-css-document-written-in-a-markup-language-48.png";
import django from "../assets/Icons/icons8-django-a-high-level-python-web-framework-that-encourages-rapid-development-24.png";
import express from "../assets/Icons/icons8-express-js-64.png";
import figma from "../assets/Icons/icons8-figma-240.png";
import firebase from "../assets/Icons/icons8-firebase-48.png";
import git from "../assets/Icons/icons8-git-256.png";
import github from "../assets/Icons/icons8-github-240.png";
import html from "../assets/Icons/icons8-html-5-48.png";
import javascript from "../assets/Icons/icons8-javascript-48.png";
import material from "../assets/Icons/icons8-material-ui-240.png";
import netlify from "../assets/Icons/icons8-netlify-a-cloud-computing-company-that-offers-hosting-and-serverless-backend-services-for-static-websites.-100.png";
import node from "../assets/Icons/icons8-node-js-48.png";
import python from "../assets/Icons/icons8-python-200.png";
import react from "../assets/Icons/icons8-react-80.png";
import rest from "../assets/Icons/icons8-rest-api-64.png";
import vscode from "../assets/Icons/icons8-source-code-96.png";
import tailwind from "../assets/Icons/icons8-tailwindcss-48.png";
import postman from "../assets/Icons/postman.png";
import colorSharp from "../assets/img/color-sharp.png";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="skill bg-transparent" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>Skills</h2>
              <p>Skills that I'm good at are enlisted below!</p>
              <Carousel
                responsive={responsive}
                infinite={true}
                className="owl-carousel owl-theme skill-slider"
              >
                <div className="item">
                  <img src={javascript} alt="Image" />
                  <h5>JavaScript</h5>
                </div>
                <div className="item">
                  <img src={react} alt="Image" />
                  <h5>React</h5>
                </div>
                <div className="item">
                  <img src={firebase} alt="Image" />
                  <h5>Firebase</h5>
                </div>

                <div className="item">
                  <img src={html} alt="Image" />
                  <h5>HTML 5</h5>
                </div>

                <div className="item">
                  <img src={css} alt="Image" />
                  <h5>CSS 3</h5>
                </div>
                <div className="item">
                  <img src={bootstap} alt="Image" />
                  <h5>Bootstrap 5</h5>
                </div>
                <div className="item">
                  <img src={tailwind} alt="Image" />
                  <h5>Tailwind Css</h5>
                </div>
                <div className="item">
                  <img src={node} alt="Image" />
                  <h5>Node Js</h5>
                </div>
                <div className="item">
                  <img src={express} alt="Image" />
                  <h5>Express Js</h5>
                </div>
                <div className="item">
                  <img src={rest} alt="Image" />
                  <h5>Rest Api</h5>
                </div>
                <div className="item">
                  <img src={axios} alt="Image" />
                  <h5>Axios</h5>
                </div>
                <div className="item">
                  <img src={python} alt="Image" />
                  <h5>Python</h5>
                </div>
                <div className="item">
                  <img src={django} alt="Image" />
                  <h5>Django</h5>
                </div>
                <div className="item">
                  <img src={material} alt="Image" />
                  <h5>Material UI</h5>
                </div>
                <div className="item">
                  <img src={git} alt="Image" />
                  <h5>Git</h5>
                </div>
                <div className="item">
                  <img src={github} alt="Image" />
                  <h5>GitHub</h5>
                </div>
                <div className="item">
                  <img src={figma} alt="Image" />
                  <h5>Figma</h5>
                </div>
                <div className="item">
                  <img src={vscode} alt="Image" />
                  <h5>VS Code</h5>
                </div>
                <div className="item">
                  <img src={netlify} alt="Image" />
                  <h5>Netlify</h5>
                </div>
                <div className="item">
                  <img src={postman} alt="Image" />
                  <h5>Postman</h5>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  );
};
